import * as React from 'react'
import { useIsLoggedInQuery, useUserIdQuery, useUserQuery } from 'auth/hooks'
import {
  hashOpenAiUser,
  isOpenAiPixelReady,
  openAiPixelReadyEventName,
  setOpenAiUser,
} from './index'

export function useOpenAiUserMatching() {
  const isLoggedInQuery = useIsLoggedInQuery()
  const userIdQuery = useUserIdQuery()
  const isLoggedIn = Boolean(isLoggedInQuery.data)
  const emailQuery = useUserQuery(undefined, {
    enabled: isLoggedIn,
    select: data => data.me?.user?.email,
  })
  const userId = isLoggedIn ? userIdQuery.data : undefined
  const email = isLoggedIn ? emailQuery.data : undefined
  const sentKeyRef = React.useRef<string | undefined>(undefined)

  React.useEffect(() => {
    if (!userId) {
      return
    }

    const key = `${userId}:${email ?? ''}`
    let isCancelled = false

    async function sendUser() {
      if (sentKeyRef.current === key || !isOpenAiPixelReady()) {
        return
      }
      const user = await hashOpenAiUser({ email, externalId: userId })
      if (isCancelled || sentKeyRef.current === key) {
        return
      }
      setOpenAiUser(user)
      sentKeyRef.current = key
    }

    void sendUser()
    window.addEventListener(openAiPixelReadyEventName, sendUser)

    return () => {
      isCancelled = true
      window.removeEventListener(openAiPixelReadyEventName, sendUser)
    }
  }, [userId, email])
}
